var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_vm._v(" You are not authorized. ")])}
var staticRenderFns = []

export { render, staticRenderFns }